import { useEffect, useState } from "react";
import { getBookingsByArtist } from "../../../api/bookingsApi";
import PageLoader from "../../../components/pageLoader";
import Toast from "../../../components/toast";
import ToastContainer from "../../../components/toastContainer";
import { getBookingStatus } from "../../../utils/getBookingStatus";

const BookingsTab = ({ artist }) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const data = await getBookingsByArtist(artist.id);
      const list = Array.isArray(data) ? data : data.results || [];
      setBookings(list);
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || "Failed to load bookings",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (artist?.id) {
      fetchBookings();
    }
  }, [artist?.id]);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="space-y-6 p-4">
      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {bookings.map((booking) => (
          <div
            key={booking.id}
            className="bg-slate-900/60 border border-white/10 rounded-xl flex flex-col"
          >
            {/* Flyer */}
            <div className="w-full h-40 bg-slate-800 rounded-lg flex items-center justify-center mb-4 overflow-hidden">
              {booking.flyer ? (
                <img
                  src={booking.flyer}
                  alt="Event flyer"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-slate-500 text-sm">No Flyer</span>
              )}
            </div>

            {/* Info */}
            <div className="space-y-1 text-sm p-4">
              <p className="text-white font-medium">Booking ID: {booking.id}</p>

              <p className="text-slate-400">
                <span className="text-white">
                  {(() => {
                    const status = getBookingStatus(booking.status);

                    return (
                      <p className="text-slate-400">
                        Status:{" "}
                        <span className={status.color}>{status.label}</span>
                      </p>
                    );
                  })()}
                </span>
              </p>

              <p className="text-slate-400">
                Artist Rating:{" "}
                <span className="text-white">
                  {booking.artist_rating ?? "-"}
                </span>
              </p>

              <p className="text-slate-400">
                Promoter Rating:{" "}
                <span className="text-white">
                  {booking.promoter_rating ?? "-"}
                </span>
              </p>
            </div>
          </div>
        ))}

        {!bookings.length && (
          <div className="col-span-full text-center text-slate-400 py-10">
            No bookings found
          </div>
        )}
      </div>

      {/* Toast */}
      <ToastContainer>
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </ToastContainer>
    </div>
  );
};

export default BookingsTab;
